import Grid from 'material-ui/Grid';

export default Grid;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Grid/index.ts